import { render, staticRenderFns } from "./PollAdmin.vue?vue&type=template&id=5cfa6d42&"
import script from "./PollAdmin.vue?vue&type=script&lang=js&"
export * from "./PollAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports